import { createRouter, createWebHistory } from 'vue-router'

import DashboardView from '@/views/DashboardView.vue'
import UsersView from '@/views/UsersView.vue'
import SettingsView from '@/views/SettingsView.vue'
import LoginView from '@/views/LoginView.vue'
import galleryView from '@/views/sections/galleryView.vue'
import nosotrosView from '@/views/sections/nosotrosView.vue'
import contactoView from '@/views/sections/contactoView.vue'
import serviciosView from '@/views/services/services.view.vue'
import testimoniosView from '@/views/sections/testimoniosView.vue'
import sectionsView from '@/views/sections/sectionsView.vue'
import cotizacionesNew from '@/views/cotizacion/cotizacionNew.vue'
import cotizacionesList from '@/views/cotizacion/cotizacionList.vue'
import cotizacionesOpciones from '@/views/cotizacion/cotizacionOpciones.vue'

const routes = [
  { path: '/', redirect: '/dashboard' },

  {
    path: '/login',
    component: LoginView,
    meta: { title: 'Login', icon: 'mdi-login' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: { requiresAuth: true, title: 'Dashboard', icon: 'mdi-view-dashboard' }
  },
  {
    path: '/users',
    name: 'Usuarios',
    component: UsersView,
    meta: { requiresAuth: true, title: 'Lista de Usuarios', icon: 'mdi-account-group' }
  },
  {
    path: '/roles',
    name: 'Roles',
    component: SettingsView,
    meta: { requiresAuth: true, title: 'Roles', icon: 'mdi-account-key' }
  },
  {
    path: '/secciones',
    name: 'Secciones',
    component: sectionsView,
    meta: { requiresAuth: true, title: 'Secciones', icon: 'mdi-view-list' }
  },
  {
    path: '/gallery',
    name: 'Galeria',
    component: galleryView,
    meta: { requiresAuth: true, title: 'Galería', icon: 'mdi-image' }
  },
  {
    path: '/nosotros',
    name: 'Nosotros',
    component: nosotrosView,
    meta: { requiresAuth: true, title: 'Nosotros', icon: 'mdi-account-multiple' }
  },
  {
    path: '/contacto',
    name: 'Contacto',
    component: contactoView,
    meta: { requiresAuth: true, title: 'Contacto', icon: 'mdi-email' }
  },
  // {
  //   path: '/servicios',
  //   name: 'Servicios',
  //   component: serviciosView,
  //   meta: { requiresAuth: true, title: 'Servicios', icon: 'mdi-hammer-wrench' }
  // },
  {
    path: '/testimonios',
    name: 'Testimonios',
    component: testimoniosView,
    meta: { requiresAuth: true, title: 'Testimonios', icon: 'mdi-comment-quote' }
  },
  {
    path: '/settings/general',
    name: 'Configuración',
    component: SettingsView,
    meta: { requiresAuth: true, title: 'Configuración General', icon: 'mdi-cog' }
  },
  {
    path: '/settings/security',
    name: 'Seguridad',
    component: SettingsView,
    meta: { requiresAuth: true, title: 'Seguridad', icon: 'mdi-shield-lock' }
  },
  {
    path: '/servicios',
    name: 'Servicios',
    component: serviciosView,
    meta: { requiresAuth: true, title: 'Servicios', icon: 'mdi-hammer-wrench' }
  },
  {
    path: '/cotizaciones/new',
    name: 'Nueva cotización',
    component: cotizacionesNew,
    meta: { requiresAuth: true, title: 'Nueva cotización', icon: 'mdi-file-document' }
  },
  {
    path: '/cotizaciones/list',
    name: 'Historial de cotizaciones',
    component: cotizacionesList,
    meta: { requiresAuth: true, title: 'Historial de cotizaciones', icon: 'mdi-file-document' }
  },
  {
    path: '/cotizaciones/opciones',
    name: 'Cotizaciones con opciones',
    component: cotizacionesOpciones,
    meta: { requiresAuth: true, title: 'Cotizaciones con opciones', icon: 'mdi-file-document' }
  }
]

export const router = createRouter({
  history: createWebHistory(),
  routes
})

// ✅ Middleware de autenticación
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

// ✅ Título dinámico
router.afterEach((to) => {
  const pageTitle = to.meta.title as string
  if (pageTitle) {
    document.title = `Admin | ${pageTitle}`
  } else {
    document.title = 'Admin Panel'
  }
})
export default router
